globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.modules = appVisitor.modules || {};

appVisitor.modules.AnalyticsEventTrackable = (function() {
  function AnalyticsEventTrackable() {}

  AnalyticsEventTrackable.prototype = {
    setAnalyticsEvent: function(data, callback) {
      this.data       = data;
      this.eventType  = appVisitor.config.analyticsEventsType;

      if(typeof callback == 'function') callback();
    },
    sendAnalyticsEvent: function(data) {
      if(!this.data || !this.eventType) return false;
      data = $.extend({}, this.data, data || {});

      if(this.eventType == "matomo") {
        if(typeof _paq == 'object') _paq.push(this.adaptEventForMatomo(data));
      }

      if(this.eventType == "google") {
        if(typeof ga == 'function') ga('send', 'event', this.adaptEventForGa(data));
      }
    },
    adaptEventForMatomo: function(data) {
      // Indexes: trackEvent = 0, category = 1, action = 2, name = 3, value = 4 (optional)
      var newEvent = []
      newEvent.push("trackEvent");
      newEvent.push(data.category || "")
      newEvent.push(data.action || "")
      newEvent.push(data.name || "")
      if(data.value)  { newEvent.push(data.value) };
      return newEvent
    },
    adaptEventForGa: function(data) {
      var newData = {};
      if(data.category) { newData["eventCategory"] = data.category };
      if(data.action)   { newData["eventAction"]   = data.action };
      if(data.name)     { newData["eventLabel"]    = data.name };
      return newData
    }
  }

  return AnalyticsEventTrackable;
})();
